<template>
    <section>
      <div class="col-md-12 tab-one-wrapper">
          <form id="filter-charts">
              <div class="row col-10">
                <label for="inputSelectQueue">Filtro de Filas para os Gráficos</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="selectType"><i class="fas fa-chart-bar"></i></span>
                  </div>
                  <select class="form-control" name="selectedQueue" id="inputSelectQueue" v-model="chartFilter" required aria-label="Tipo" aria-describedby="selectType">
                    <option value="*" selected>Todos</option>
                  </select>
                </div>
            </div>
          </form>
  
          <div class="wrapper-charts">
            <PizzaChartAnswered :filter="chartFilter"></PizzaChartAnswered>
            <PizzaChartAbandoned :filter="chartFilter"></PizzaChartAbandoned>
          </div>
        </div>
        
        <div class="col-md-12 tab-two-wrapper">
          <div class="wrapper-group">
            <AverageTimeCalls type="serviceTime" :filter="chartFilter"></AverageTimeCalls>
            <AverageTimeCalls type="waitingTime" :filter="chartFilter"></AverageTimeCalls>
          </div>
  
          <div>
            <OperatorProductivityChart :filter="chartFilter"></OperatorProductivityChart>
            <MixedChart :filter="chartFilter"></MixedChart>
          </div>
        </div>
    </section>
  </template>
  
  <script>
  import AverageTimeCalls from "../charts/AverageTimeCalls.vue";
  import OperatorProductivityChart from "../charts/OperatorProductivityChart.vue";
  import MixedChart from "../charts/MixedChart.vue";
  import PizzaChartAnswered from "../charts/PizzaChartAnswered.vue";
  import PizzaChartAbandoned from "../charts/PizzaChartAbandoned.vue";
  
  export default {
    name: "DashboardApp",
    components: {
      AverageTimeCalls,
      OperatorProductivityChart,
      MixedChart,
      PizzaChartAnswered,
      PizzaChartAbandoned
    },
    data() {
      return {
        toogleRealtime: false,
        intervalId: "",
        cl: "toogle",
        chartFilter: "*"
      };
    },
    created() {
      this.intervalId = setInterval(() => {
        this.toogleRealtime = !this.toogleRealtime;
      }, 15000);
    },
    methods: {
      setRT(style) {
        this.cl = style;
        clearInterval(this.intervalId);
      },
      updateCharts() {
        this.chartFilter;
      }
    },
  };
  </script>
  
  <style scoped>
  .tab-one-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  
  .wrapper-charts {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
  
  #filter-charts {
    margin-left: 2%;
  }
  
  .tab-two-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  
  .sub-group {
    width: 45%;
  }
  
  .wrapper-group {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }
  
  .toogle-el {
    display: none;
  }
  </style>